import { domReady } from '../../utils'

const toggler = () => {
  const toggerButtons = Array.from(
    document.querySelectorAll('.toggerButtonSideBar')
  )

  const setAsCollapsed = () => {
    document.addEventListener('DOMContentLoaded', function() {
      $('body').trigger('resize')
      $('.scroll-sidebar, .slimScrollDiv')
      .css('overflow-x', 'visible')
      .parent()
      .css('overflow', 'visible')
      $('body').addClass('mini-sidebar')
      $('.navbar-brand span').hide()
    })

    window.localStorage.setItem('sidebar', 'n-collapsed')
    // console.log('SetAsCollapsed')
  }

  const setAsUnCollapsed = () => {
    document.addEventListener('DOMContentLoaded', function() {
      $('body').trigger('resize')
      $('.scroll-sidebar, .slimScrollDiv')
      .css('overflow', 'hidden')
      .parent()
      .css('overflow', 'visible')
      $('body').removeClass('mini-sidebar')
      $('.navbar-brand span').show()
    })

    window.localStorage.setItem('sidebar', 'n-uncollapsed')
    // console.log('SetAsUnCollapsed')
  }

  const getActualStage = () => window.localStorage.getItem('sidebar')

  if (getActualStage() === null) {
    window.localStorage.setItem('sidebar', 'n-uncollapsed')
    setAsUnCollapsed()
  }

  getActualStage() === 'n-collapsed' ? setAsCollapsed() : setAsUnCollapsed()

  toggerButtons.map(toggerButton => {
    toggerButton.onclick = () => {
        if (getActualStage() == 'n-collapsed') {
          setAsUnCollapsed()
        } else {
          setAsCollapsed()
        }
    }
  })
}

export default domReady(toggler)
